import { render, staticRenderFns } from "./EvaluationPerformanceFileModelPage.vue?vue&type=template&id=67c37195&"
import script from "./EvaluationPerformanceFileModelPage.vue?vue&type=script&lang=js&"
export * from "./EvaluationPerformanceFileModelPage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports